import { render, staticRenderFns } from "./DetailTaxPph22Import.vue?vue&type=template&id=49078902"
import script from "./DetailTaxPph22Import.vue?vue&type=script&lang=js"
export * from "./DetailTaxPph22Import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports